import React from "react";

import { useCancelFieldReactivation, useGetFarms, useTranslation } from "utils";

import { Icon, Modal, Typography, Message as message } from "components";

type CancelFieldReactivationModalProps = {
  fieldId: string;
  fieldName?: string | null;
  visible: boolean;
  onClose: () => void;
};

export const CancelFieldReactivationModal = ({ fieldId, fieldName, visible, onClose }: CancelFieldReactivationModalProps) => {
  const { t } = useTranslation(["farm"]);
  const { currentFarm } = useGetFarms();
  const { mutateAsync: cancelFieldReactivation, isPending } = useCancelFieldReactivation(fieldId, currentFarm?.id);

  const handleConfirm = async () => {
    try {
      await cancelFieldReactivation();
      message({ content: t("farm:cancelReactivationModal.success"), icon: "tick" });
    } catch {
      message({ content: t("farm:cancelReactivationModal.error"), icon: "error" });
    } finally {
      onClose();
    }
  };

  return (
    <Modal
      dataTestId="cancel-field-reactivation-modal"
      showModal={visible}
      onOk={handleConfirm}
      onCancel={onClose}
      confirmLoading={isPending}
      okText={t("farm:cancelReactivationModal.confirm")}
      cancelText={t("farm:cancelReactivationModal.cancel")}
      zIndex={9999}
      destroyOnHidden={true}
      title={
        <>
          <Icon iconName="tabler/alert-circle" className="inline icon margin-right-75" size="m" fill="#DB3804" color="#FFF" />
          <Typography variant="paragraph-m" className="headline-3">
            {t("farm:cancelReactivationModal.title", { fieldName: fieldName ?? "" })}
          </Typography>
        </>
      }
      content={<Typography variant="paragraph-m">{t("farm:cancelReactivationModal.message", { fieldName: fieldName ?? "" })}</Typography>}
    />
  );
};
